__turbopack_context__.v({
  "button": "style-module__hP7D-a__button",
  "callbutton": "style-module__hP7D-a__callbutton",
  "callimg": "style-module__hP7D-a__callimg",
  "fixedbutton": "style-module__hP7D-a__fixedbutton",
  "fixedcallbutton": "style-module__hP7D-a__fixedcallbutton",
});
